/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = POSReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class POSReturnItemsEditor extends _Ext.GridEditorBase<POSReturnItemsRow> {
        inlineEditAllowed: boolean;


        protected getColumnsKey() { return "Retail.POSReturnItems"; }
        protected getDialogType() { return POSReturnItemsDialog; }
        protected getLocalTextPrefix() { return POSReturnItemsRow.localTextPrefix; }
        protected form: POSReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }

        // #region Variables
        public salespersonId = 0;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;

        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number; 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }


        setMasterValues() {
            this.RateListId = (this.parentDialog as POSReturnDialog).RateListId;
            this.LaborListId = (this.parentDialog as POSReturnDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as POSReturnDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as POSReturnDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as POSReturnDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as POSReturnDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as POSReturnDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as POSReturnDialog).form.TransDate.valueAsDate; 
            this.PartyId = parseInt((this.parentDialog as POSReturnDialog).form.POSCustomerId.value);
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
             
            if (this.inlineEditAllowed) {
                Q.first(columns, x => x.field === fld.Pieces).format = int;
                var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
                Q.first(columns, x => x.field === fld.Weight).format = wt;
            }

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            POSReturnDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {
                        
                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id); 

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
              
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;


            var oldvalues: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    oldvalues = response.Entity,
                { async: false });

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                var oldpieces = 0;

                oldpieces = oldvalues.Pieces;
                if (value > oldpieces) {
                    Q.alert('Invalid Pieces value');
                    item[field] = oldpieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                }
                item[field] = value;

                this.view.updateItem(id, item);
                this.view.refresh();
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                var oldweight = 0.0;
                oldweight = oldvalues.Weight;
                
                if (value > oldweight) {
                    Q.alert('Invalid Weight value');
                    item[field] = oldweight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }


                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            var grid = POSSalesItemsSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.PartyId, 
                        }
                         
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.TransItemId), GridFilters: filters
                        });


                    }


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        var ItemDetails = ItemGridHelper.SetReturnItemGrid(selectedItems2);
                        this.setData(ItemDetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        }

        getItemData(items) {
            let x;
            for (let rateitem of items) {
                rateitem[this.getIdProperty()] = "`" + this.nextId++;
                //   alert('ID ' + rateitem.CostId);

                x.push(rateitem);
            }
            return x;
        }

        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) { 
            for (let Itemdetail of ItemDetails) {
                var labors = Itemdetail.LaborDetails;
                if (labors != null && labors.length > 0) {
                    for (let labor of labors) {
                        delete labor.OriginalLabourRate;
                        delete labor.OriginalLabourAmount;
                        delete labor.CCLabourAmount;
                    }
                }
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion 
    }
}